import {
  animate,
  animateChild,
  animation,
  AnimationEvent,
  group,
  keyframes,
  query,
  state,
  style,
  transition,
  trigger,
  useAnimation,
} from '@angular/animations';
import { DOCUMENT, PlatformLocation } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceService } from '@app/core';
import { BackKeyUrlService } from '../header/back-key-url.service';

export type FadeState = 'down' | 'up';

@Component({
  selector: 'navaar-container-scroll',
  templateUrl: './container-scroll.component.html',
  styleUrls: ['./container-scroll.component.scss'],
  animations: [
    trigger('stateContainer', [
      state(
        'down',
        style({ visibility: 'hidden', 'z-index': -1 }),
      ),
      state(
        'up',
        style({ transform: 'translate3d(0, 0, 0)', 'z-index': 5 }),
      ),
      transition('down => up', [
        group([
          useAnimation(animation([
            animate(
              '500ms 0ms',
              keyframes([
                style({ visibility: 'visible', transform: 'translate3d(0, 100%, 0)', easing: 'ease', offset: 0, 'z-index': 5 }),
                style({ transform: 'translate3d(0, 0, 0)', easing: 'ease', offset: 1 })
              ])
            )
          ])),
          ...[query('@*', animateChild(), { optional: true })]
        ])
      ]),
      transition('up => down', [
        group([
          useAnimation(animation([
            animate(
              '500ms',
              keyframes([
                style({ transform: 'translate3d(0, 10%, 0)', easing: 'ease', offset: 0 }),
                style({ visibility: 'hidden', transform: 'translate3d(0, 100%, 0)', easing: 'ease', offset: 1 })
              ])
            )
          ])),
          ...[query('@*', animateChild(), { optional: true })]
        ])
      ]),
    ]),
    trigger('stateHeader', [
      state(
        'up',
        style({ visibility: 'hidden', 'z-index': -1 }),
      ),
      state(
        'down',
        style({ transform: 'translate3d(0, 0, 0)', 'z-index': 5 }),
      ),
      transition('up => down', [
        group([
          useAnimation(animation([
            animate(
              '500ms 0ms',
              keyframes([
                style({ visibility: 'visible', transform: 'translate3d(0, -100%, 0)', easing: 'ease', offset: 0, 'z-index': 5 }),
                style({ transform: 'translate3d(0, 0, 0)', easing: 'ease', offset: 1 })
              ])
            )
          ])),
          ...[query('@*', animateChild(), { optional: true })]
        ])
      ]),
      transition('down => up', [
        group([
          useAnimation(animation([
            animate(
              '500ms',
              keyframes([
                style({ transform: 'translate3d(0, 0, 0)', easing: 'ease', offset: 0 }),
                style({ visibility: 'hidden', transform: 'translate3d(0, -100%, 0)', easing: 'ease', offset: 1 })
              ])
            )
          ])),
          ...[query('@*', animateChild(), { optional: true })]
        ])
      ])
    ])
  ]
})

export class ContainerScrollComponent implements OnInit, OnDestroy {

  @Input() public showHeader: boolean = false;
  @Input() public showIcon: boolean = true;
  @Input() public title: string;
  @Input('show-button-close') public isBtnClose: boolean;
  @Input('back-url') public backUrl: string[] | null = null;
  @Input() public isPlayAnimation: boolean = true;
  @Input() public isFixedContainer: boolean = false;
  @Input() public preventScroll: boolean = false;
  public state: FadeState = 'down';
  public stateHeader: FadeState = 'up';
  private _show: boolean;
  public isDisableAnimationByVersionApp: boolean = true;
  @Output('close') public _close: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  set show(value: boolean) {
    if (value) {
      this._show = value;
      this.state = 'up';
      this.stateHeader = 'down';
    } else {
      this.state = 'down';
      this.stateHeader = 'up';
    }
  }

  get show() {
    return this._show;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private readonly route: Router,
    private readonly device: DeviceService,
    private readonly location: PlatformLocation,
    private readonly backKeyUrlService: BackKeyUrlService,
    private readonly render: Renderer2) { }

  public animationDone(event: AnimationEvent) {
    if (this.isPlayAnimation) {
      if ((event.fromState === 'void' || event.fromState === 'up') && event.toState === 'down') {
        this._show = false;
        this.render.removeStyle(this.document.body, 'overflow');
      }
    }
  }

  ngOnInit(): void {
    this.isDisableAnimationByVersionApp = this.device.isDisableAnimation();
  }

  public animationHeaderDone(event: AnimationEvent) { }

  public close() {
    if (this.isBtnClose) {
      this.show = false;
      this._close.emit(false);
    } else {
      this.backKeyUrlService.goBack(this.backUrl);
    }
  }

  ngOnDestroy(): void { }
}

